import { render, staticRenderFns } from "./SearchCompanyResult.vue?vue&type=template&id=ed79d00c&scoped=true"
import script from "./SearchCompanyResult.vue?vue&type=script&lang=js"
export * from "./SearchCompanyResult.vue?vue&type=script&lang=js"
import style0 from "./SearchCompanyResult.vue?vue&type=style&index=0&id=ed79d00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed79d00c",
  null
  
)

export default component.exports